import AuthLayout from '@/app/layout/authLayout'
import { RecoveryForm } from '@/app/entities/auth/ui/recovery/RecoveryForm'

export const RecoveryPage = () => {
    return (
        <AuthLayout>
            <RecoveryForm />
        </AuthLayout>
    )
}
